<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
                <v-overlay :value="overlay2" absolute opacity="0.8">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
                <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="Salvar">
                    <v-card-title class="primary white--text">
                        <span class="text-h5">Editar Usuário</span>
                    </v-card-title>
                    <v-card-text class="pt-4">
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field label="Nome completo*" v-model="usuario.nomeUsuario"
                                        :rules="ruleRequired" outlined dense clearable></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-combobox :rules="ruleRequired" v-model="roleSelected" :items="roles"
                                        item-text="descricao" label="Perfil de Acesso*" item-value="descricao" outlined
                                        dense return-object></v-combobox>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-text-field label="Email*" v-model="usuario.Usuario_username"
                                        :rules="ruleEmailRequired" outlined dense clearable></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-text-field label="Telefone" v-model="usuario.telefone" outlined dense
                                        clearable></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-text-field label="Bilhete de Identidade" v-model="usuario.idPessoa" outlined
                                        dense clearable></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                        <small class="grey--text">*campos obrigatórios</small>
                    </v-card-text>
                    <v-card-actions class="px-6 pb-4">
                        <v-spacer></v-spacer>
                        <v-btn color="red" text @click="fecharDialogo(false)">
                            Cancelar
                        </v-btn>
                        <v-btn color="primary" :disabled="!valid" type="submit" depressed>
                            Editar
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import axios from "@/plugins/axios";
import Swal from "sweetalert2";
const ls = require("local-storage");

export default {
    props: ['usuario'],
    data: () => ({
        dialog: true,
        overlay2: false,
        valid: true,
        showPassword: false,
        nome: "",
        roleSelected: null,
        email: "",
        password: "",
        telefone: "",
        bilhete: "",
        roles: [],
        ruleRequired: [(value) => !!value || "Campo obrigatório"],
        ruleEmailRequired: [
            (value) => !!value || "E-mail obrigatório",
            (value) => value.length <= 50 || "Máximo de 50 caracteres",
            (value) => {
                const pattern =
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "E-mail inválido";
            },
        ]
    }),

    computed: {
        userNivel() {
            return ls.get("nivel_user");
        },
        fkUsuario() {
            return ls.get("pkUsuario");
        }
    },

    created() {
        this.InitializeRoles();
    },

    methods: {
        async InitializeRoles() {
            this.overlay2 = true;
            try {
                this.roles = await axios.get("/rolesFindAll").then((res) => res.data);
                if (this.userNivel) {
                    this.roles = this.roles.filter((r) => r.nivel >= this.userNivel);
                }
                this.roleSelected = this.roles.filter((r) => r.nome == this.usuario.autorizacoes_nome)[0]
            } catch (error) {
                Swal.fire("Ocorreu um erro ao carregar os perfis", "", "error");
            } finally {
                this.overlay2 = false;
            }
        },

        async Salvar() {
            if (this.$refs.form.validate()) {
                this.overlay2 = true;
                try {
                    let params = {
                        pkUsuarioAutor: this.fkUsuario,
                        autor: ls.get("nomeUsuario"),
                        pkUsuario: this.usuario.pkUsuario,
                        nome: this.usuario.nomeUsuario,
                        email: this.usuario.Usuario_username,
                        telefone: this.usuario.telefone,
                        role: this.roleSelected.descricao !== undefined ? this.roleSelected.nome : this.roleSelected,
                        bi: this.usuario.idPessoa,
                        enable: 1,
                        senha: ''
                    };

                    console.log(params);


                    let result = await axios.post("/UsuarioOrUpdate", params);

                    if (result.status == 200) {
                        Swal.fire("Usuário editado com sucesso", "", "success");
                        this.dialog = false;
                        this.fecharDialogo(true)
                    } else {
                        Swal.fire("Informação", "Erro ao editar os dados", "warning");
                    }
                } catch (error) {
                    Swal.fire("Erro", "Ocorreu um erro ao cadastrar o usuário", "error");
                } finally {
                    this.overlay2 = false;
                }
            }
        },

        fecharDialogo(bool) {
            this.dialog = false;
            this.$emit('fecharComponente', bool)
        },
    },
};
</script>

<style scoped>
.v-card__title {
    padding: 16px 24px;
}

.v-card__actions {
    padding: 8px 16px;
}
</style>